// extracted by mini-css-extract-plugin
export default {"page":"SupportRequestsPage_page__gyUiS","pane":"SupportRequestsPage_pane__T1AXe"};